import axios from 'axios';
import store from '../store'
import router from '../router'
import { login } from './auth';
import { base64_encode } from "./util.js";
import { Dialog,Toast } from "vant";

let { apiUrl, appKey, appSecret, channel,serviceUser,servicePro } = process.env.CONFIG;

const Messages = {
  internalServerError: '抱歉，服务异常，请稍后尝试。',
  unknownError: '抱歉，遇到未知错误，请稍后重试。',
  loginRequired: '登录过期，请重新登录。'
}

const checkErrorMessage = (error) => {
  if (error && error.response) {
    switch (error.response.status) {
      case 400: return '请求错误(400)';
      case 401: return '未授权，请重新登录(401)';
      case 403: return '拒绝访问(403)';
      case 404: return '请求出错(404)';
      case 408: return '请求超时(408)';
      case 500: return '服务器错误(500)';
      case 501: return '服务未实现(501)';
      case 502: return '网络错误(502)';
      case 503: return '服务不可用(503)';
      case 504: return '网络超时(504)';
      case 505: return 'HTTP版本不受支持(505)';
      default: return `连接出错(${error.response.status})!`;
    }
  }
  return '连接服务器失败!'
}

const CancelToken = axios.CancelToken;
export const http = async (service ,url, params, cancelCallBack = null) => {
  return new Promise(async (resolve, reject) => {
    let token;
    try {
      token = await checkAccessToken();
    } catch (error) {
      reject(error)
    }
    const config = {
      baseURL: apiUrl + service,
      url: url,
      method: params && params.type || 'get',
      timeout: params.timeout && params.timeout || 30000,
      params: params && params.param || {},
      data: params && params.body || {},
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'Channel': channel,
        'sessionToken': window.local.getValue('sessionKey'),
      },
      cancelToken: new CancelToken(function executor(c) {
        cancelCallBack && cancelCallBack(c)
      })
    }
    axios(config).then((response) => {
      if (response.status === 200) {
        if(!response.data.Status && response.data.ErrorCode == 401) {
          resolve({ Status:false, Data:null, Message:'登录超时,请重新登录' });
          login(store, router);// 会话过期
          return;
        }

        resolve(response.data);
        return;
      }
      reject(Messages.internalServerError);
    }).catch((error) => {
      if (axios.isCancel(error)) {
        reject(null);
        return;
      }
      if (error.response && error.response.status === 401) {
        getAccessToken();
      }
        if (error.response && error.response.status === 408) {
            Toast.clear();
            Dialog({confirmButtonText:'关闭',message:'网络超时' })
        }
        if(error.message && error.message.indexOf('Network Error') > -1){
            Toast.clear();
            Dialog({confirmButtonText:'关闭',message:'网络错误' })
        }
      reject(checkErrorMessage(error));
    })
  })
}

export const httpUser = async (url, params, cancelCallBack = null) => {
  return http("/api/" + serviceUser,url,params,cancelCallBack)
}


export const httpOpen = async (url, params, cancelCallBack = null) => {
  return http("/api/" + servicePro,url,params,cancelCallBack)
}

export const getAccessToken = async () => {
  return new Promise((resolve, reject) => {
    axios({
      url: apiUrl + '/oauth/token?grant_type=client_credentials',
      method: 'post',
      timeout: 10000,
      headers: {
        'Authorization': "Basic " + base64_encode(`${appKey}:${appSecret}`)
      }
    }).then((response) => {
      if (response.status === 200) {
        const expireAt = new Date().getTime() + (response.data.expires_in - 600) * 1000;
        const value = JSON.stringify({ accessToken: response.data.access_token, expireAt: expireAt })
        window.local.save('access_token', value);
        resolve(response.data.access_token);
      } else {
        reject(`获取服务器授权失败 ${response.status}`);
      }
    }).catch((error) => {
      reject(checkErrorMessage(error));
    })
  })
}

export const checkAccessToken = async () => {
  const access_token = window.local.get('access_token');
  if (access_token) {
    const accessToken = JSON.parse(access_token);
    const time = new Date().getTime();
    if (time < accessToken.expireAt) {
      return accessToken.accessToken;
    }
  }
  return await getAccessToken();
}